<script>
// 请勿使用 ！！！
// do not use it ！！！
// and fuck off now ！！！
import Vue from 'vue'
export default {
  props: {
    elId: {
      type: String,
      default: 'outside-render'
    }
  },
  data: () => ({
    renderNodes: null
  }),
  render: h => h(),
  mounted() {
    let el = document.getElementById(this.elId)
    if (!el) {
      el = document.createElement('div')
      el.id = this.elId
      document.body.appendChild(el)
    }
    this.renderNodes = this.$scopedSlots.default
    this.newer = new Vue({
      el,
      parent: this,
      render: h => (this.renderNodes ? this.renderNodes() : h())
    })
  },
  updated() {
    this.renderNodes = this.$scopedSlots.default
  },
  destroyed() {
    this.newer && this.newer.$destroy()
    delete this.newer
  }
}
</script>
